'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var objectWithoutProperties = require('../../objectWithoutProperties-aa43106a.js');
var _extends = require('../../extends-f8003900.js');
var React = require('react');
var index = require('../../index-0e40e0c2.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var withIntlAriaAttrs = require('../../withIntlAriaAttrs-7e974861.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../breakpoints-7bb24b2d.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../GlobalStyle/GlobalStyle.js');
require('styled-components');
require('../../theme-340a6118.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../defineProperty-3cad0327.js');
require('../../xstyled-prop-types.es-56667676.js');
require('../../utils/isType/isType.js');
require('../../utils/ref/refType.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var colorMap = {
  "default": xstyledStyledComponents_es.css(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    &:hover:not(:disabled),\n    &:focus:not(:disabled),\n    &:active:not(:disabled) {\n      color: ", ";\n    }\n  "])), styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('primary', 'default'), styles_themeUtils.nuDSColor('primary', 'light')),
  primary: xstyledStyledComponents_es.css(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    &:hover:not(:disabled),\n    &:focus:not(:disabled),\n    &:active:not(:disabled) {\n      background-color: ", ";\n    }\n  "])), styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('white'), styles_themeUtils.nuDSColor('primary', 'light')),
  secondary: xstyledStyledComponents_es.css(_templateObject3 || (_templateObject3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    &:hover:not(:disabled), &:focus:not(:disabled), &:active:not(:disabled) {\n      background-color: ", ";\n    }\n  "])), styles_themeUtils.nuDSColor('white', 'dark'), styles_themeUtils.nuDSColor('black', 'defaultT70'), styles_themeUtils.nuDSColor('white', 'dark'))
};
var outlineColorMap = {
  primary: xstyledStyledComponents_es.css(_templateObject4 || (_templateObject4 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    border-color: ", ";\n    color: ", ";\n    background-color: transparent;\n    &:hover:not(:disabled),\n    &:focus:not(:disabled),\n    &:active:not(:disabled) {\n      background-color: ", ";\n    }\n\n    &:disabled {\n      border-color: ", ";\n      background-color: transparent;\n    }\n  "])), styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('primary'), styles_themeUtils.nuDSColor('primary', 'defaultL10'), styles_themeUtils.nuDSColor('black', 'defaultT20'))
};
var textColorMap = {
  primary: xstyledStyledComponents_es.css(_templateObject5 || (_templateObject5 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    ", "\n  "])), outlineColorMap.primary),
  "default": xstyledStyledComponents_es.css(_templateObject6 || (_templateObject6 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    background-color: transparent;\n    color: ", ";\n    &:hover:not(:disabled),\n    &:focus:not(:disabled),\n    &:active:not(:disabled) {\n      color: ", ";\n    }\n    &:disabled {\n      background-color: transparent;\n      color: ", ";\n    }\n  "])), styles_themeUtils.nuDSColor('white', 'dark'), styles_themeUtils.nuDSColor('primary', 'light'), styles_themeUtils.nuDSColor('white', 'defaultT70'))
};

var varyStyles = function varyStyles(_ref) {
  var color = _ref.color,
      variant = _ref.variant;
  var variantMap = {
    text: xstyledStyledComponents_es.css(_templateObject7 || (_templateObject7 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      ", "\n    "])), textColorMap[color]),
    contained: xstyledStyledComponents_es.css(_templateObject8 || (_templateObject8 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      ", "\n      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 0px 2px rgba(0, 0, 0, 0.14);\n    "])), colorMap[color])
  };
  return variantMap[variant];
};

var fullWidthStyles = function fullWidthStyles(_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth && xstyledStyledComponents_es.css(_templateObject9 || (_templateObject9 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  width: 100%;\n"])));
};

var Button$1 = xstyledStyledComponents_es.styled.button(_templateObject10 || (_templateObject10 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  appearance: none;\n  border-radius: 2px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  text-align: center;\n  padding: 19px 32px;\n  user-select: none;\n  min-height: 56px;\n  transition: ease-in-out 200ms;\n  transition-property: background, color;\n  white-space: nowrap;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  &:disabled {\n    background-color: ", ";\n    cursor: not-allowed;\n    box-shadow: none;\n    color: ", ";\n  }\n\n  ", ";\n  ", ";\n"])), styles_themeUtils.nuDSColor('white', 'dark'), styles_themeUtils.nuDSColor('black', 'defaultT20'), varyStyles, fullWidthStyles);
Button$1.displayName = 'Button';
Button$1.propTypes = {
  color: index.PropTypes.oneOf(['default', 'primary']).isRequired,
  fullWidth: index.PropTypes.bool.isRequired
};

var BaseButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default['default'].createElement(Button$1, _extends._extends({}, props, {
    ref: ref
  }));
});
BaseButton.defaultProps = {
  color: 'default',
  fullWidth: false
};
BaseButton.propTypes = {
  color: index.PropTypes.oneOf(['default', 'primary']),
  fullWidth: index.PropTypes.bool
};

function renderTypographyComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var children = arguments.length > 1 ? arguments[1] : undefined;
  return /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], _extends._extends({
    color: "inherit"
  }, props), children);
}

function DeprecatedButton(props) {
  var children = props.children,
      href = props.href;
      props.activeClassName;
      var buttonRef = props.buttonRef;
      props.locale;
      props.forceRefresh;
      var intlKey = props.intlKey,
      typographyVariant = props.typographyVariant,
      rest = objectWithoutProperties.objectWithoutProperties(props, ["children", "href", "activeClassName", "buttonRef", "locale", "forceRefresh", "intlKey", "typographyVariant"]);

  var as = href ? 'a' : 'button';
  var componentChildren = renderTypographyComponent({
    intlKey: intlKey,
    variant: typographyVariant,
    strong: true
  }, children);
  return /*#__PURE__*/React__default['default'].createElement(BaseButton, _extends._extends({}, rest, as === 'a' && {
    href: href
  }, {
    as: as,
    ref: buttonRef
  }), componentChildren);
}

DeprecatedButton.defaultProps = {
  color: 'default',
  variant: 'text',
  disabled: false,
  fullWidth: false,
  onClick: undefined,
  type: 'button',
  className: undefined,
  activeClassName: null,
  href: '',
  intlKey: '',
  children: undefined,
  buttonRef: undefined,
  locale: null,
  forceRefresh: false,
  typographyVariant: 'button'
};
DeprecatedButton.propTypes = {
  activeClassName: index.PropTypes.string,
  buttonRef: index.PropTypes.shape({
    current: index.PropTypes.oneOfType([index.PropTypes.element, index.PropTypes.object])
  }),
  children: index.PropTypes.node,
  className: index.PropTypes.string,
  color: index.PropTypes.oneOf(['default', 'primary', 'secondary']),
  disabled: index.PropTypes.bool,
  forceRefresh: index.PropTypes.bool,
  fullWidth: index.PropTypes.bool,
  href: index.PropTypes.string,
  intlKey: index.PropTypes.string,
  locale: index.PropTypes.string,
  onClick: index.PropTypes.func,
  type: index.PropTypes.string,
  typographyVariant: components_Typography_Typography.typographyVariantsPropType,
  variant: index.PropTypes.oneOf(['text', 'contained'])
};
var Button = withIntlAriaAttrs.withIntlAriaAttrs(DeprecatedButton);

exports.default = Button;
//# sourceMappingURL=DeprecatedButton.js.map
